import PropTypes from 'prop-types';
import React from 'react';
import { config } from 'config';
import { useTheme } from 'styled-components';
import {
    Container,
    ContentContainer,
    Header,
    RedirectTo,
    RightActionTitle,
    Title
} from './styled';
import {
    Loader,
    MaterialIcon
} from 'mol-ui';
const { redirectAfterLogin } = config;

const FormLayout = ({
    children,
    goBackTo = redirectAfterLogin,
    loading = false,
    mode,
    rightAction,
    rightActionTitle,
    title
}) => {

    const { textColor }  = useTheme();
    return (
        <Container>
            <Header>
                <RedirectTo to={ goBackTo }>
                    <MaterialIcon color={ textColor } icon="navigate_before" size={ 14 } />
                </RedirectTo>
                <Title>{ title }</Title>
                {
                    (rightActionTitle && (mode !== 'view' && mode !== 'edit')) &&
                    <RightActionTitle onClick={ rightAction }>
                        { rightActionTitle }
                    </RightActionTitle>
                }
            </Header>
            <ContentContainer>
                {
                    loading
                        ? <Loader active={ true } />
                        : children
                }
            </ContentContainer>
        </Container>
    );
};

FormLayout.propTypes = {
    children: PropTypes.any,
    goBackTo: PropTypes.string,
    loading: PropTypes.bool,
    mode: PropTypes.string,
    rightAction: PropTypes.func,
    rightActionTitle: PropTypes.string,
    title: PropTypes.string
};

FormLayout.displayName = 'FormLayout';

export default FormLayout;
